import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage('de')}
        className={`h-8 px-2 ${language === 'de' ? 'text-primary font-semibold' : 'text-muted-foreground'}`}
      >
        DE
      </Button>
      <span className="text-muted-foreground">|</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage('en')}
        className={`h-8 px-2 ${language === 'en' ? 'text-primary font-semibold' : 'text-muted-foreground'}`}
      >
        EN
      </Button>
    </div>
  );
};

export default LanguageSwitcher;
